module.exports = __webpack_public_path__ + "static/m_solution14-5fb38f8f03a0a3b3442e47aef6a0ff9c.png";